import React from 'react';
import PropTypes from 'prop-types';
import spin from './styles/spin.svg';
import bars from './styles/bars.svg';
import puff from './styles/puff.svg';
import dots from './styles/dots.svg';

const loaderMapper = {
  spin,
  bars,
  puff,
  dots
};

export default function Loader({size, type}) {
  return (
    <div className={`loader ${size}`} style={{backgroundImage: `url(${loaderMapper[type]})`}}>
      Loading...
    </div>
  );
}

Loader.defaultProps = {
  size: 'medium',
  type: 'spin'
};

Loader.propTypes = {
  type: PropTypes.oneOf(['dots', 'spin', 'bars', 'puff']),
  size: PropTypes.oneOf(['small', 'medium'])
};
